<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article class="post-30 page type-page status-publish hentry">
          <div class="entry-content">
            <!-- PHASE 1 -->
            <div class="hc-managed-firewall hc-managed-firewall-color">
              <div class="container">
                <div class="row">
                  <div class="col-sm-6">
                    <h2 class="wow fadeIn">Personal Cyber Harassments</h2>
                    <div class="wow fadeIn margin-top-bottom-20">
                      <p>
                        Our content removal process is developed to solve issues
                        of cyber harassment and cyberbullying, and it extends a
                        helping hand to internet users disturbed by any kind of
                        cyber harassments as well as victims of cybercrime.
                      </p>
                      <p>
                        Our intention is to help people who are victimized by
                        the abuse of cyber, either by harassment or bullying,
                        via creating a conducive environment which could make
                        their life beautiful and peaceful.
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-full hc-managed-firewall-img"
                        src="/static/assets/images/personal_cyber_harassments.png"
                        alt="Managed-Firewall-layer-1"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- PHASE 2 -->
            <div class="clearfix"></div>
            <div class="row hc-managed-firewall-hard">
              <div class="col-sm-12">
                <div
                  class="title-subtile-holder wow fadeIn animated hc-visible"
                >
                  <h1 class="section-title dark_title">
                    What is Cyber Harassment and Cyber Bullying
                  </h1>
                  <div class="section-subtitle dark_subtitle">
                    Also called Internet Harassment and Internet Bullying
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-about-us">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          The use of electronic means i.e., information and
                          communication technology to harass, control,
                          manipulate or habitually disparage a person or group
                          without a direct or implied threat of physical harm is
                          called the Cyber Harassment. Unlike physical
                          harassment which involves face-to-face contact, cyber
                          harassment uses cyberspace to abuse a person, group or
                          organization and it could be in the form of verbal,
                          sexual, emotional or social. It was observed that the
                          ultimate objective of a cyber-harasser is to exert
                          power and control over the targeted victim.
                        </span>
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          When this type of cyber harassment takes place among
                          children or teenagers, it is described widely in the
                          field as Cyberbullying. In other words, when someone
                          harass or bully others on the internet, particularly
                          on social media sites it is called cyber harassment
                          (adults involved) or cyberbullying (children or
                          teenagers involved). Further, when it moves to the
                          next level, i.e. if the abuse becomes an ‘obsession’
                          or indicates fixation or is excessively repeated and
                          aggressive in its nature, this cyber harassment
                          becomes Cyber Stalking.
                        </span>
                      </p>
                    </div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          Harassment or bullying becomes harmful when posting
                          rumors, threats, sexual remarks, a victims' personal
                          information, or hate speech. This is normally
                          identified by its repeated behavior and/or actions.
                        </span>
                      </p>
                    </div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          Many victims suffer mentally, since it directly
                          attacks the self-esteem of a person, and develops
                          negative emotional responses, including being scared,
                          frustrated, angry, and depressed. In some cases,
                          caused to suicidal ideation.
                        </span>
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          Furthermore, the revenge and black mail could be
                          identified as the advanced levels of cyber harassment
                          since they demand money or sexual favours, very often.
                          In many cases, these types of cyber harassments are
                          associated with secret photography/covert photography
                          as well as faked or doctored documents, photos or
                          videos.
                        </span>
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span>
                          Information and communication technology today uses
                          many new words and definitions to describe the Cyber
                          Harassment &amp; Cyber Bullying. Therefore, a general
                          clarification of most common forms of Cyber Harassment
                          &amp; Cyber Bullying with their brief definition and
                          related concepts are recommended to look into before
                          discussing the subject matter further.
                        </span>
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- PHASE 3 -->
            <div class="hc-home-hosting-wp-support">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn no-margin hc-h1">Revenge Porn</h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Revenge porn, the shorten form of revenge pornography is
                        used to describe the dissemination of sexually explicit
                        images or videos or audios of individuals without their
                        permission. The sexually explicit pictures, videos or
                        audios may be made by a partner too as a result of their
                        intimate relationship with or without the knowledge or
                        consent of the other. This kind of material could be
                        used by a cyber-harasser to blackmail them, asking to
                        perform more sex acts, to coerce them into continuing
                        the relationship, to punish them for ending the
                        relationship, or to silence them. This practice could be
                        described as a form of psychological abuse and domestic
                        violence, as well as a form of sexual abuse. Therefore,
                        in many countries legislations have been passed to
                        outlaw this type of practices.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        Further, the term &quot;revenge porn&quot; generally
                        refers to the uploading of sexually explicit material to
                        humiliate and intimidate a person, who has broken off
                        the relationship. It was observed that this term has
                        been often misused to describe &quot;non revenge&quot;
                        scenarios too, including nonconsensual pornography
                        distributed by hackers or by individuals seeking profit
                        or notoriety. The images, videos and audios posted are
                        usually accompanied by sufficient information to
                        identify the pictured individual, typically names and
                        locations, and can include links to social media
                        profiles, home addresses and workplaces.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        Some incidents were reported, where victim’s images,
                        videos, audios were exposed to their workplaces and as a
                        result they lost their jobs and found themselves
                        difficult to get a new job. The effect of this type of
                        revenge porn is so severe that many will not be able to
                        bear. Therefore, it has been suggested even to change
                        the term from &quot;revenge porn&quot; to
                        &quot;image-based sexual abuse.&quot;
                      </p>
                    </div>
                    <div class="spacer_10"></div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Sextortion
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Sextortion is termed as another kind of “revenge porn”
                        that employs non-physical forms of coercion to extort
                        sexual favors from the victim with a threat of releasing
                        sexual images, videos, audios or information.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div class="wow fadeIn">
                      <p class="hc-p">
                        Sextortion could be referred to a form of blackmail too
                        if sexual information or videos, audios, images are used
                        to extort sexual favors from the victim. Here the social
                        media and text messages are often used as the source of
                        sexual material and the victims are threatened to share
                        them with others unless comply with their demands. These
                        demands are typically for money, further intimate
                        images, or sexual favours.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Sexting
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        The communication of sexually explicit messages, images
                        or videos or audios normally done via mobile phones,
                        computers or any kind of digital device is termed as
                        Sexting. It can be lead to revenge porn, webcam
                        blackmail and sextortion. This exchange could happen
                        between two romantic partners as well as between others
                        outside the relationship. It also can happen between
                        people who are not yet in a relationship, but hope to
                        be. With the introduction of camera phone/smartphone
                        Sexting has become more common. However, the sexting can
                        be considered both as a positive or negative experience
                        depending on the consent for sharing the images.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Webcam Blackmail
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Sextortion via the use of webcams is also a concern,
                        especially for those who use webcams for flirting and
                        cybersex. Thereby, the webcam blackmail is considered as
                        a part of sextortion.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Sextortion via the use of webcams is also a concern,
                        especially for those who use webcams for flirting and
                        cybersex. Thereby, the webcam blackmail is considered as
                        a part of sextortion.
                      </p>
                    </div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Webcam blackmail usually involves someone being lured
                        into sharing private images/video footages of themselves
                        with another person online. The victim is then told that
                        they have been recorded and the footage will be made
                        public if they do not comply and meet their demands such
                        as pay out a substantial amount of money or explicit
                        more images of the victim. Teens and young people can be
                        particularly vulnerable to webcam blackmail.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        An increase in webcam blackmails has been reported
                        recently, and it affects both young and old, male and
                        female alike. Webcam blackmail is also connected with
                        webcam trolling.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Cyberstalking
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Cyberstalking is an advanced form of cyber
                        harassment/cyberbullying as mentioned in our
                        introductory note of cyber abuse. When the Internet or
                        other electronic means are used to stalk or harass an
                        individual, group, or organization, it is identified as
                        cyberstalking. It normally includes false accusations,
                        defamation, slander and libel. It may also include
                        monitoring, identity theft, threats, vandalism,
                        solicitation for sex, or gathering information that may
                        be used to threaten, embarrass or harass.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        A stalker may be an online stranger or a person known to
                        the targeted victim. He/she also may be anonymous and
                        solicits the involvement of other people online, who do
                        not even know the targeted victim. Therefore, in some
                        countries, cyberstalking is categorized as a criminal
                        offense and its conviction can result in a restraining
                        order, probation, or criminal penalties against the
                        stalker, including jail.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Outing
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        When a bully shares personal and private information,
                        images, audios, or videos about someone publicly, it is
                        called Outing. A person or a group of victims could be
                        embarrassed or publicly humiliated by posting sensitive
                        or secret information about him/her/them online, without
                        his/her/their consent. The final outcome is that
                        he/she/they will be outed when his/her/their information
                        is disseminated throughout the internet.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        The absence of consent in this situation is very
                        serious, as it can have legal implications. Depending on
                        the country, this can go from a small punishment to
                        severe one. For example, someone may post private and
                        sensitive information about you or your child that you
                        or your child didn’t want to publicly share. This is
                        often associated with outing a child’s sexual
                        orientation before he or she is comfortable with sharing
                        that information. Outing can involve any type of
                        information that serves to fuel for bullying.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        On the other hand, outing has become a serious issue
                        within LGBT communities as it can disclose an LGBT&#39;s
                        sexual orientation or gender identity without that
                        person&#39;s consent. Outing gives rise to issues of
                        privacy, choice, hypocrisy, and harm in addition to
                        sparking debate on what constitutes common good in
                        efforts to combat homophobia and heterosexism.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Trolling
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Trolling is described as deliberate acts for provoking
                        responses through the use of insults, controversial
                        statements and off-topic messages on online forums and
                        social networking sites. Thereby, an online troll could
                        be someone who enjoys messing with a community, by
                        posting aggressive and provocative messages that will
                        trigger emotional responses from others. It was observed
                        that this has become favorite hobby of some of the
                        internet users who are active on at least one social
                        media with no shame whatsoever.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        In the process, the troll will personally attack
                        you/your child with the intention of making you angry
                        enough to act in the same way. Trolls usually spend
                        their time looking for arguments. The worst thing is
                        that they feel good by making others feel bad.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Another peculiar category of troll is the Meme-reliant
                        trolls, who are not scared to share their views and
                        opinions for provocation and often, they harass others
                        by doctoring images of victims. Sometimes, the videos of
                        victims are too doctored by them with the intention of
                        provocation.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Dissing / Denigration
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        The act of sending or posting hurtful or defamatory
                        information online with the intention of tarnishing any
                        other person’s reputation is identified as Dissing. This
                        is normally done by cyber bullies via posting pictures,
                        screenshots or videos to put down a victim by destroying
                        his/her reputation.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        The word Denigration has a similar meaning and it is an
                        act of sullying or defaming someone's reputation via
                        spreading negative or hurtful information. The verb
                        denigrate means to make black or blacken. Email, instant
                        messaging, chat rooms, and/or websites are extensively
                        used nowadays to denigrate not only individuals but also
                        reputed companies.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Trickery
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        If a cyberbully gains the trust of a person, only to
                        have him/her to reveal his/her embarrassing or secret
                        information and then use it against the victim by
                        sharing them online, it is defined as Trickery. This
                        also is called confidence trick, in some situations.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Catfishing
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Catfishing is a very clear deceptive activity where a
                        cyberbully creates a fake profile/identity on a social
                        network account to befriend with a specific victim for
                        abuse, deception or fraud. Then the offender
                        communicates with the victim or his/her child or family
                        and acquires personal information about the victim,
                        his/her child or family and use the same against the
                        victim.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        The person who does this could be called as “Catfish”
                        and is usually hiding his or her real identity, so it is
                        difficult to bring about any kind of punishment.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Catfishing is often observed on dating websites employed
                        for romance scams. It could be worst if Catfishing is
                        used for financial gains, to compromise a victim in some
                        way, or simply as a form of trolling or wish
                        fulfillment.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Impersonation
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Impersonation can happen in different ways. A cyberbully
                        can use a false identity to torment his/her victim, thus
                        covering his/her own tracks. A cyberbully also can
                        impersonate someone his/her victim knows, perhaps to
                        damage relationships or wheedle information out of their
                        victim. The worst is when a cyberbully impersonates
                        his/her victim in order to ruin the reputation of
                        victim.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        There are people who create online presence in someone
                        else's name, simply by creating a social media account.
                        The key problem here is that these accounts are created
                        with less-than-stellar intentions in mind, leaving the
                        cyberbully open to harassment claims with
                        photoshoped/doctored/edited nude photos, brag about
                        rampant drug use or otherwise inaccurately depict the
                        person they are pretending to be.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        An impersonator is someone who imitates or copies the
                        behavior or actions of another, sometimes with good
                        intention and in lawful manner.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Doxxing / Doxing
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        “Doxing” (also spelled ‘doxxing’) is the short worse for
                        “dropping docs” and can be identified as a revenge
                        tactic.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        When someone researches and broadcasts private
                        information about another person or organization, it is
                        called Doxing. The methods employed to acquire this
                        information include finding out a person’s private
                        accounts and online activities by searching publicly
                        available databases and social media websites (like
                        Facebook), hacking, and social engineering. It is
                        closely related to Internet vigilantism and hacktivism.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Even in today’s developed world, the doxing is widely
                        used to publish someone’s sensitive personal information
                        online in an attempt to harass, intimidate, extort,
                        stalk, or steal the identity of a target. “Sensitive
                        information” can include social security numbers, phone
                        numbers, home addresses, personal photos, employment
                        information, email addresses, and family members’
                        personal information.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <br />
                    <div class="clearfix"></div>
                    <div
                      class="wow fadeIn"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        This has been well seen in scenarios where a person
                        sends something online that other people don't agree
                        with, and they may retaliate by making sender’s personal
                        information completely public, sometimes with
                        catastrophic consequences.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- PHASE 4 -->
            <div class="clearfix"></div>
            <div class="hc-start-web">
              <div class="container">
                <div class="row">
                  <div class="col-sm-8">
                    <h3 class="wow fadeIn" style="color: white">
                      To get details of our services offered for content
                      removal, please click
                    </h3>
                  </div>
                  <div class="col-sm-4">
                    <div class="spacer_7"></div>
                    <div class="clearfix"></div>
                    <div class="hc-btn-read-more-bk-red wow fadeIn">
                      <a href="/personal" title>Personal Service</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your IP",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "personal_harassment",
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/personal_harassment.vue